import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes";
import { LanguageProvider } from "./i18n/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import { TenantProvider } from "./contexts/TenantContext";

function App() {
  return (
    <BrowserRouter>
      <TenantProvider>
        <AuthProvider>
          <LanguageProvider>
            <Routes />
          </LanguageProvider>
        </AuthProvider>
      </TenantProvider>
    </BrowserRouter>
  );
}

export default App;
